module.exports = __webpack_public_path__ + "static/media/warren.495acbfa.png";